import { Phone, MessageCircle } from "lucide-react";
import { PHONE, PHONE_LINK, WHATSAPP_LINK } from "../lib/data";

const StickyBar = () => (
  <>
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 p-3 bg-white/90 backdrop-blur-md border-t border-[#EADFC6]" data-testid="sticky-phone-bar">
      <a
        href={PHONE_LINK}
        data-testid="sticky-phone-call-button"
        className="flex items-center justify-center gap-3 w-full bg-[#A6823B] text-white font-semibold py-3.5 rounded-full shadow-lg shadow-[#A6823B]/30 active:scale-[0.98] transition-transform"
      >
        <span className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center pulse-ring">
          <Phone className="w-4 h-4" />
        </span>
        Sună pentru programare · {PHONE}
      </a>
    </div>
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Scrie-ne pe WhatsApp"
      className="fixed z-50 right-4 bottom-24 lg:bottom-6 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl shadow-[#25D366]/40 hover:scale-105 active:scale-95 transition-transform"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <MessageCircle className="w-7 h-7 relative fill-white" />
    </a>
  </>
);

export default StickyBar;
